module.exports = "nav.navbar-expand-lg {\n  margin: -1rem;\n  padding: 1rem; }\n"